import {
  ClipboardCheck,
  DatabaseZap,
  FileText,
  FormInput,
  LayoutTemplate,
  Bot,
  LogOut,
  LucideNotebookText,
  Settings,
  ShieldAlert,
  Users2Icon,
} from "lucide-react";
import IconAccount from "../components/svg/IconAccount";
import IconAllocation from "../components/svg/IconAllocation";
import IconData from "../components/svg/IconData";
import IconPortfolio from "../components/svg/IconPortfolio";
import IconReporting from "../components/svg/IconReporting";
import IconAsset from "../components/svg/IconAsset";
import IconAnalytics from "../components/svg/IconAnalytics";
import IconPrices from "../components/svg/IconPrices";
import IconByod from "../components/svg/IconByod";
import IconProfile from "../components/svg/IconProfile";
import IconIssuer from "../components/svg/IconIssuer";
import IconPolicy from "../components/svg/IconPolicy";
import chroma from "chroma-js";
import IconFolder from "../components/svg/IconFolder";
import IconTolerance from "../components/svg/IconTolerance";
import IconKey from "@/components/svg/IconKey";

export const dashboardNavigation = [
  {
    id: "1",
    link: "Portfolios",
    href: "/",
    icon: (
      <IconPortfolio className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  // {
  //   id: "2",
  //   link: "Tolerance Manager",
  //   href: "/tolerance-manager",
  //   icon: (
  //     <IconTolerance className="w-5 h-5 text-white group-[.active]:text-themeV2" />
  //   ),
  // },
  {
    id: "2",
    link: "Allocations",
    href: "/allocation",
    icon: (
      <IconAllocation className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "2b",
    link: "Trade Impact",
    href: "/compliance/trade-impact",
    icon: (
      <FormInput className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "3",
    link: "Analysis",
    href: "/analysis",
    icon: (
      <IconReporting className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "4",
    link: "Tolerance Manager",
    href: "/tolerance-manager",
    icon: (
      <IconTolerance className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "5",
    link: "Clients",
    href: "/clients/dashboard",
    icon: (
      <Users2Icon className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  // W57 (§6.A wave 3, decision A5): the IPS builder is the authoring front
  // end of Mandates & Documents and lives in the Control workspace now. The
  // manager reads the governing policy on the portfolio page instead.
  {
    id: "7",
    link: "Data",
    href: "/data/asset",
    icon: (
      <IconData className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
    hasChild: true,
    childrenNavigation: [
      // { link: "Assets", href: "/data/asset", icon: <IconAsset className="w-5 h-5 text-white group-[.active]:text-themeV2" /> },
      {
        link: "Portfolio",
        href: "/data/portfolios",
        icon: (
          <IconPortfolio className="w-5 h-5 text-white/70 group-[.active]:text-themeV2" />
        ),
      },
      {
        link: "Portfolio-Groups",
        href: "/data/portfolio-groups",
        icon: (
          <IconFolder className="w-5 h-5 text-white/70 group-[.active]:text-themeV2" />
        ),
      },
      {
        link: "Assets",
        href: "/data/assets/dashboard",
        icon: (
          <IconAsset className="w-5 h-5 text-white group-[.active]:text-themeV2" />
        ),
      },
      // { link: "Issuers", href: "/data/issuer", icon: <IconIssuer className="w-5 h-5 text-white group-[.active]:text-themeV2" /> },
      {
        link: "Issuers",
        href: "/data/issuers/dashboard",
        icon: (
          <IconIssuer className="w-5 h-5 text-white group-[.active]:text-themeV2" />
        ),
      },
      {
        link: "Prices",
        href: "/data/prices",
        icon: (
          <IconPrices className="w-5 h-5 text-white group-[.active]:text-themeV2" />
        ),
      },
      {
        link: "BYOD",
        href: "/data/BYOD",
        icon: (
          <IconByod className="w-5 h-5 text-white group-[.active]:text-themeV2" />
        ),
      },
    ],
  },
  {
    id: "8",
    link: "Account",
    href: "/account/profile",
    icon: (
      <IconAccount className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
    hasChild: true,
    childrenNavigation: [
      {
        link: "Profile",
        href: "/account/profile",
        icon: (
          <IconProfile
            strokeWidth={"2.2"}
            className="w-5 h-5 text-white group-[.active]:text-themeV2"
          />
        ),
      },
      {
        link: "Organisation",
        href: "/account/organisation",
        icon: (
          <Users2Icon
            strokeWidth={"2.2"}
            className="w-5 h-5 text-white group-[.active]:text-themeV2"
          />
        ),
      },
      {
        link: "Exit & portability",
        href: "/account/exit",
        icon: (
          <LogOut
            strokeWidth={"2.2"}
            className="w-5 h-5 text-white group-[.active]:text-themeV2"
          />
        ),
      },
      {
        link: "Setting",
        href: "/account/setting",
        icon: (
          <Settings
            strokeWidth={"2.2"}
            className="w-5 h-5 text-white group-[.active]:text-themeV2"
          />
        ),
      },
    ],
  },
  //  {link:"Setting",href:"/setting",icon:<Settings strokeWidth={"2.2"} className="w-5 h-5 text-white group-[.active]:text-themeV2"/>},
];

// The Control workspace (PRD v1.1 §A/WSP-*): the compliance surfaces over
// the same records the Investment workspace manages. Offered to members
// holding a control-side organisation role (useWorkspace.js decides).
export const controlNavigation = [
  {
    id: "c1",
    link: "Compliance",
    href: "/compliance",
    icon: (
      <IconReporting className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c1b",
    link: "Mandates & Documents",
    href: "/compliance/documents",
    icon: (
      <FileText className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  // W57 (§6.A): Mandates & Documents ▸ Author — the IPS builder (templates,
  // forms, signatures, sharing) whose completed form issues as a governing
  // document version.
  {
    id: "c1c",
    link: "Policy Author",
    href: "/policies/forms",
    icon: (
      <LucideNotebookText className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c2",
    link: "Rules",
    href: "/compliance/rules",
    icon: (
      <IconTolerance className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3",
    link: "Monitoring",
    href: "/compliance/monitoring",
    icon: (
      <IconAnalytics className="w-5 h-5 text-white fill-white group-[.active]:text-themeV2" />
    ),
  },
  // W67 (UI-002): exposure by dimension, limits and headroom by rule.
  {
    id: "c3x",
    link: "Exposure & Headroom",
    href: "/compliance/exposure",
    icon: (
      <LayoutTemplate className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3a2",
    link: "Trade Impact",
    href: "/compliance/trade-impact",
    icon: (
      <FormInput className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3b",
    link: "Data & Quality",
    href: "/compliance/data-quality",
    icon: (
      <DatabaseZap className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3b1",
    link: "Data Feeds",
    href: "/compliance/data-feeds",
    icon: (
      <DatabaseZap className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3b0",
    link: "Entities & Register",
    href: "/compliance/entities",
    icon: (
      <LayoutTemplate className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3b3",
    link: "FX & Conversion",
    href: "/compliance/fx",
    icon: (
      <DatabaseZap className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3b5",
    link: "Ingest",
    href: "/compliance/ingest",
    icon: (
      <DatabaseZap className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3b4",
    link: "Reference Governance",
    href: "/compliance/reference",
    icon: (
      <DatabaseZap className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3b2",
    link: "Instruments & Exposure",
    href: "/compliance/instruments",
    icon: (
      <LayoutTemplate className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3c",
    link: "Cases & Waivers",
    href: "/compliance/cases",
    icon: (
      <ShieldAlert className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3d",
    link: "Attestations",
    href: "/compliance/attestations",
    icon: (
      <ClipboardCheck className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3e",
    link: "Reports",
    href: "/compliance/reports",
    icon: (
      <IconReporting className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3f",
    link: "Audit",
    href: "/compliance/audit",
    icon: (
      <LucideNotebookText className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c3b",
    link: "AI governance",
    href: "/compliance/ai-governance",
    icon: (
      <Bot className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c4",
    link: "Organisation",
    href: "/account/organisation",
    icon: (
      <Users2Icon className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "c5",
    link: "Account",
    href: "/account/profile",
    icon: (
      <IconAccount className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
];

export const adminDashboardNavigation = [
  {
    id: "1",
    link: "User",
    href: "/admin",
    icon: (
      <IconProfile className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "2",
    link: "Api Key",
    href: "/admin/api-key",
    icon: (
      <IconKey className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
  },
  {
    id: "3",
    link: "Account",
    href: "/account/admin/profile",
    icon: (
      <IconAccount className="w-5 h-5 text-white group-[.active]:text-themeV2" />
    ),
    hasChild: true,
    childrenNavigation: [
      {
        link: "Setting",
        href: "/admin/account/setting",
        icon: (
          <Settings
            strokeWidth={"2.2"}
            className="w-5 h-5 text-white group-[.active]:text-themeV2"
          />
        ),
      },
    ],
  },
  //  {link:"Setting",href:"/setting",icon:<Settings strokeWidth={"2.2"} className="w-5 h-5 text-white group-[.active]:text-themeV2"/>},
];

export const colorOptions = [
  { value: "ocean", label: "#Ocean", color: "#00B8D9" },
  { value: "blue", label: "#Blue", color: "#0052CC" },
  { value: "purple", label: "#Purple", color: "#5243AA" },
  { value: "red", label: "#Red", color: "#FF5630" },
  { value: "orange", label: "#Orange", color: "#FF8B00" },
  { value: "yellow", label: "#Yellow", color: "#FFC400" },
  { value: "green", label: "#Green", color: "#36B37E" },
  { value: "forest", label: "#Forest", color: "#00875A" },
  { value: "slate", label: "#Slate", color: "#253858" },
  { value: "silver", label: "#Silver", color: "#666666" },
];
// export const colorOptions = [
//     { value: 'ocean', label: '#Ocean', color: '#00B8D9', isFixed: true },
//     { value: 'blue', label: '#Blue', color: '#0052CC', isDisabled: true },
//     { value: 'purple', label: '#Purple', color: '#5243AA' },
//     { value: 'red', label: '#Red', color: '#FF5630', isFixed: true },
//     { value: 'orange', label: '#Orange', color: '#FF8B00' },
//     { value: 'yellow', label: '#Yellow', color: '#FFC400' },
//     { value: 'green', label: '#Green', color: '#36B37E' },
//     { value: 'forest', label: '#Forest', color: '#00875A' },
//     { value: 'slate', label: '#Slate', color: '#253858' },
//     { value: 'silver', label: '#Silver', color: '#666666' },
// ];

// Given color array
export const colorArray = [
  "#FF6633",
  "#FFB399",
  "#FF33FF",
  "#FFFF99",
  "#00B3E6",
  "#E6B333",
  "#3366E6",
  "#999966",
  "#809980",
  "#E6FF80",
  "#1AFF33",
  "#999933",
  "#FF3380",
  "#CCCC00",
  "#66E64D",
  "#4D80CC",
  "#FF4D4D",
  "#99E6E6",
  "#6666FF",
  "#FF6633",
  "#FFB399",
  "#FF33FF",
  "#FFFF99",
  "#00B3E6",
  "#E6B333",
  "#3366E6",
  "#999966",
  "#99FF99",
  "#B34D4D",
  "#80B300",
  "#809900",
  "#E6B3B3",
  "#6680B3",
  "#66991A",
  "#FF99E6",
  "#CCFF1A",
  "#FF1A66",
  "#E6331A",
  "#33FFCC",
  "#66994D",
  "#B366CC",
  "#4D8000",
  "#B33300",
  "#CC80CC",
  "#66664D",
  "#991AFF",
  "#E666FF",
  "#4DB3FF",
  "#1AB399",
  "#E666B3",
  "#33991A",
  "#CC9999",
  "#B3B31A",
  "#00E680",
  "#4D8066",
  "#809980",
  "#E6FF80",
  "#1AFF33",
  "#999933",
  "#FF3380",
  "#CCCC00",
  "#66E64D",
  "#4D80CC",
  "#9900B3",
  "#E64D66",
  "#4DB380",
  "#FF4D4D",
  "#99E6E6",
  "#6666FF",
].filter((color) => {
  // Calculate the luminance of each color using chroma-js
  const luminance = chroma(color).luminance();
  // You can adjust the luminance threshold based on your preference
  return luminance < 0.2; // Adjust this threshold as needed
});

export const data = [
  {
    id: "1",
    portfolioGroupName: "Portfolio Group One-1",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-1",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "2",
    portfolioGroupName: "Portfolio Group One-2",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-2",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "1",
    portfolioGroupName: "Portfolio Group One-1",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-1",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "2",
    portfolioGroupName: "Portfolio Group One-2",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-2",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "1",
    portfolioGroupName: "Portfolio Group One-1",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-1",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "2",
    portfolioGroupName: "Portfolio Group One-2",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-2",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "1",
    portfolioGroupName: "Portfolio Group One-1",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-1",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "2",
    portfolioGroupName: "Portfolio Group One-2",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-2",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "1",
    portfolioGroupName: "Portfolio Group One-1",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-1",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "2",
    portfolioGroupName: "Portfolio Group One-2",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-2",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "1",
    portfolioGroupName: "Portfolio Group One-1",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-1",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "2",
    portfolioGroupName: "Portfolio Group One-2",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-2",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "1",
    portfolioGroupName: "Portfolio Group One-1",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-1",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
  {
    id: "2",
    portfolioGroupName: "Portfolio Group One-2",
    portfolioCreatedDate: "Jan 4, 2024",
    portfolioGroupName2: "Portfolio Group One-2",
    portfolioCreatedDate2: "Jan 4, 2024",
  },
];

export const groupBYODOp = [
  {
    Value: 1,
    label: "Assets",
  },
  {
    Value: 2,
    label: "Issuers",
  },
];

export const typeBYODOp = [
  {
    value: 1,
    label: "Quantitative",
  },
  {
    Value: 2,
    label: "Ordinal",
  },
  {
    Value: 3,
    label: "Categorical",
  },
];
export const subTypeBYODOp = [
  {
    value: 1,
    label: "Numeric",
  },
  {
    Value: 2,
    label: "Text",
  },
];

export const subTypeBYODOption = [
  {
    Quantitative: [
      {
        value: 1,
        label: "Price",
      },
      {
        value: 2,
        label: "Options Greeks",
      },
      {
        value: 3,
        label: "Duration",
      },
      {
        value: 4,
        label: "Convexity",
      },
      {
        value: 5,
        label: "Yield",
      },
      {
        value: 6,
        label: "Volatility",
      },
      {
        value: 7,
        label: "Other",
      },
    ],
    Ordinal: [
      {
        value: 1,
        label: "Numeric",
      },
      {
        Value: 2,
        label: "Text",
      },
    ],
  },
];

export const subsubTypeBYODOption = [
  {
    Price: [
      {
        value: 1,
        label: "Open",
      },
      {
        value: 2,
        label: "Close",
      },
      {
        value: 3,
        label: "High",
      },
      {
        value: 4,
        label: "Low",
      },
      {
        value: 5,
        label: "Adj Close",
      },
      {
        value: 6,
        label: "Other",
      },
    ],
    OptionsGreeks: [
      {
        value: 1,
        label: "Delta",
      },
      {
        value: 2,
        label: "Gamma",
      },
      {
        value: 3,
        label: "Theta",
      },
      {
        value: 4,
        label: "Vega",
      },
      {
        value: 5,
        label: "Rho",
      },
    ],
    Duration: [
      {
        value: 1,
        label: "Macaulay",
      },
      {
        value: 2,
        label: "Modified",
      },
      {
        value: 3,
        label: "Effective",
      },
    ],

  },
];

export const financialType = [
  { id: "all", label: "All" },
  {
    id: "EQUITY",
    label: "Equity",
  },
  // {
  //     id: 3,
  //     label: 'Indices'
  // },
  {
    id: "ETF",
    label: "ETF",
  },
  {
    id: "MutualFund",
    label: "Mutual Fund",
  },
  {
    id: "bond",
    label: "Bond",
  },
];

export const dateSetPrice = [
  {
    id: 1,
    label: "Price - Adj Open",
    symbol: "adjOpen",
  },
  {
    id: 2,
    label: "Price - Adj Close",
    symbol: "adjClose",
  },
  {
    id: 3,
    label: "Price - Adj High",
    symbol: "adjHigh",
  },
  {
    id: 4,
    label: "Price - Adj Low",
    symbol: "adjLow",
  },
  {
    id: 5,
    label: "Price - Open",
    symbol: "open",
  },
  {
    id: 6,
    label: "Price - Close",
    symbol: "close",
  },
  {
    id: 7,
    label: "Price - High",
    symbol: "high",
  },
  {
    id: 8,
    label: "Price - Low",
    symbol: "low",
  },
  {
    id: 9,
    label: "Price - BYOD",
    symbol: "BYOD",
  },
];

export const statusType = [
  {
    id: 1,
    label: "No",
  },
  {
    id: 2,
    label: "Yes",
  },
];

export const frequencyOptions = [
  {
    value: "12M",
    label: "Annual",
  },
  {
    value: "6M",
    label: "Semi Annual",
  },
];

export const settlementDaysOptions = [
  {
    label: 0,
    value: 0,
  },
  {
    label: 1,
    value: 1,
  },
  {
    label: 2,
    value: 2,
  },
  {
    label: 3,
    value: 3,
  },
  {
    label: 4,
    value: 4,
  },
  {
    label: 5,
    value: 5,
  },
];

export const initialAllocation = {
  Stocks: {
    strategic: 50,
    tactical: 0,
    strategicToleranceLower: 3,
    strategicToleranceUpper: 5,
    tacticalToleranceLower: 1,
    tacticalToleranceUpper: 2,
    authorizedAsset: "N/A",
    class: "Equity",
    subClass: "Large Cap",
    strategy: "Passive",
    allocationType: "Fixed Weight",
    totalToleranceLower: 5,
    totalToleranceUpper: 7,
    subAllocations: {
      "US Stocks": {
        strategic: 30,
        tactical: 0,
        strategicToleranceLower: 2,
        strategicToleranceUpper: 3,
        tacticalToleranceLower: 1,
        tacticalToleranceUpper: 2,
        authorizedAsset: "US Large Cap Equity",
        class: "Equity",
        subClass: "Large Cap",
        strategy: "Passive",
        allocationType: "Fixed Weight",
        totalToleranceLower: 5,
        totalToleranceUpper: 7,
        subAllocations: {
          "Large Cap Growth": {
            strategic: 15,
            tactical: 0,
            strategicToleranceLower: 1,
            strategicToleranceUpper: 2,
            tacticalToleranceLower: 1,
            tacticalToleranceUpper: 1,
            authorizedAsset: "US Large Cap Growth ETF",
            class: "Equity",
            subClass: "Large Cap Growth",
            strategy: "Passive",
            allocationType: "Fixed Weight",
            totalToleranceLower: 3,
            totalToleranceUpper: 4,
            subAllocations: {
              "Tech Sector": {
                strategic: 7.5,
                tactical: 0,
                strategicToleranceLower: 0.5,
                strategicToleranceUpper: 1,
                tacticalToleranceLower: 0.5,
                tacticalToleranceUpper: 0.5,
                authorizedAsset: "Tech Sector ETF",
                class: "Equity",
                subClass: "Technology",
                strategy: "Passive",
                allocationType: "Fixed Weight",
                totalToleranceLower: 1.5,
                totalToleranceUpper: 2,
                subAllocations: {
                  "New Sector": {
                    strategic: 7.5,
                    tactical: 0,
                    strategicToleranceLower: 0.5,
                    strategicToleranceUpper: 1,
                    tacticalToleranceLower: 0.5,
                    tacticalToleranceUpper: 0.5,
                    authorizedAsset: "Tech Sector ETF",
                    class: "Equity",
                    subClass: "Technology",
                    strategy: "Passive",
                    allocationType: "Fixed Weight",
                    totalToleranceLower: 1.5,
                    totalToleranceUpper: 2,
                    subAllocations: {
                      "Layer Sector": {
                        strategic: 7.5,
                        tactical: 0,
                        strategicToleranceLower: 0.5,
                        strategicToleranceUpper: 1,
                        tacticalToleranceLower: 0.5,
                        tacticalToleranceUpper: 0.5,
                        authorizedAsset: "Tech Sector ETF",
                        class: "Equity",
                        subClass: "Technology",
                        strategy: "Passive",
                        allocationType: "Fixed Weight",
                        totalToleranceLower: 1.5,
                        totalToleranceUpper: 2,
                      },
                      "Healthcare Sector": {
                        strategic: 7.5,
                        tactical: 0,
                        strategicToleranceLower: 0.5,
                        strategicToleranceUpper: 1,
                        tacticalToleranceLower: 0.5,
                        tacticalToleranceUpper: 0.5,
                        authorizedAsset: "Healthcare Sector ETF",
                        class: "Equity",
                        subClass: "Healthcare",
                        strategy: "Passive",
                        allocationType: "Fixed Weight",
                        totalToleranceLower: 1.5,
                        totalToleranceUpper: 2,
                      },
                    },
                  },
                  "Healthcare Sector": {
                    strategic: 7.5,
                    tactical: 0,
                    strategicToleranceLower: 0.5,
                    strategicToleranceUpper: 1,
                    tacticalToleranceLower: 0.5,
                    tacticalToleranceUpper: 0.5,
                    authorizedAsset: "Healthcare Sector ETF",
                    class: "Equity",
                    subClass: "Healthcare",
                    strategy: "Passive",
                    allocationType: "Fixed Weight",
                    totalToleranceLower: 1.5,
                    totalToleranceUpper: 2,
                  },
                },
              },
              "Healthcare Sector": {
                strategic: 7.5,
                tactical: 0,
                strategicToleranceLower: 0.5,
                strategicToleranceUpper: 1,
                tacticalToleranceLower: 0.5,
                tacticalToleranceUpper: 0.5,
                authorizedAsset: "Healthcare Sector ETF",
                class: "Equity",
                subClass: "Healthcare",
                strategy: "Passive",
                allocationType: "Fixed Weight",
                totalToleranceLower: 1.5,
                totalToleranceUpper: 2,
              },
            },
          },
          "Large Cap Value": {
            strategic: 15,
            tactical: 0,
            strategicToleranceLower: 1,
            strategicToleranceUpper: 2,
            tacticalToleranceLower: 1,
            tacticalToleranceUpper: 1,
            authorizedAsset: "US Large Cap Value ETF",
            class: "Equity",
            subClass: "Large Cap Value",
            strategy: "Passive",
            allocationType: "Fixed Weight",
            totalToleranceLower: 3,
            totalToleranceUpper: 4,
          },
        },
      },
      "International Stocks": {
        strategic: 20,
        tactical: 0,
        strategicToleranceLower: 2,
        strategicToleranceUpper: 3,
        tacticalToleranceLower: 1,
        tacticalToleranceUpper: 2,
        authorizedAsset: "International Developed Equity",
        class: "Equity",
        subClass: "International Developed",
        strategy: "Active",
        allocationType: "Fixed Weight",
        totalToleranceLower: 5,
        totalToleranceUpper: 7,
      },
    },
  },
  Bonds: {
    strategic: 30,
    tactical: 0,
    strategicToleranceLower: 3,
    strategicToleranceUpper: 5,
    tacticalToleranceLower: 1,
    tacticalToleranceUpper: 2,
    authorizedAsset: "N/A",
    class: "Fixed Income",
    subClass: "Government",
    strategy: "Passive",
    allocationType: "Fixed Weight",
    totalToleranceLower: 5,
    totalToleranceUpper: 7,
    subAllocations: {
      "US Bonds": {
        strategic: 20,
        tactical: 0,
        strategicToleranceLower: 2,
        strategicToleranceUpper: 3,
        tacticalToleranceLower: 1,
        tacticalToleranceUpper: 2,
        authorizedAsset: "US Government Bonds",
        class: "Fixed Income",
        subClass: "Government",
        strategy: "Passive",
        allocationType: "Fixed Weight",
        totalToleranceLower: 5,
        totalToleranceUpper: 7,
      },
      "International Bonds": {
        strategic: 10,
        tactical: 0,
        strategicToleranceLower: 2,
        strategicToleranceUpper: 3,
        tacticalToleranceLower: 1,
        tacticalToleranceUpper: 2,
        authorizedAsset: "International Bonds",
        class: "Fixed Income",
        subClass: "International",
        strategy: "Active",
        allocationType: "Fixed Weight",
        totalToleranceLower: 5,
        totalToleranceUpper: 7,
      },
    },
  },
  "Alternative Investments": {
    strategic: 20,
    tactical: 0,
    strategicToleranceLower: 3,
    strategicToleranceUpper: 5,
    tacticalToleranceLower: 1,
    tacticalToleranceUpper: 2,
    authorizedAsset: "N/A",
    class: "Real Estate",
    subClass: "REITs",
    strategy: "Active",
    allocationType: "Fixed Weight",
    totalToleranceLower: 5,
    totalToleranceUpper: 7,
    subAllocations: {
      "Real Estate": {
        strategic: 10,
        tactical: 0,
        strategicToleranceLower: 1,
        strategicToleranceUpper: 2,
        tacticalToleranceLower: 1,
        tacticalToleranceUpper: 1,
        authorizedAsset: "Real Estate Investment Trusts",
        class: "Real Estate",
        subClass: "REITs",
        strategy: "Active",
        allocationType: "Fixed Weight",
        totalToleranceLower: 5,
        totalToleranceUpper: 7,
      },
      Commodities: {
        strategic: 5,
        tactical: 0,
        strategicToleranceLower: 1,
        strategicToleranceUpper: 2,
        tacticalToleranceLower: 1,
        tacticalToleranceUpper: 1,
        authorizedAsset: "Commodities",
        class: "Commodities",
        subClass: "Precious Metals",
        strategy: "Passive",
        allocationType: "Fixed Weight",
        totalToleranceLower: 5,
        totalToleranceUpper: 7,
      },
      Cash: {
        strategic: 5,
        tactical: 0,
        strategicToleranceLower: 1,
        strategicToleranceUpper: 2,
        tacticalToleranceLower: 1,
        tacticalToleranceUpper: 1,
        authorizedAsset: "Cash and Cash Equivalents",
        class: "Cash and Cash Equivalents",
        subClass: "Money Market",
        strategy: "Passive",
        allocationType: "Fixed Weight",
        totalToleranceLower: 5,
        totalToleranceUpper: 7,
      },
    },
  },
};

// export const initialAllocation = {
//     "Stocks": {
//         strategic: 50,
//         tactical: 0,
//         strategicToleranceLower: 3,
//         strategicToleranceUpper: 5,
//         tacticalToleranceLower: 1,
//         tacticalToleranceUpper: 2,
//         authorizedAsset: "N/A",
//         class: "Equity",
//         subClass: "Large Cap",
//         strategy: "Passive",
//         allocationType: "Fixed Weight",
//         totalToleranceLower: 5,
//         totalToleranceUpper: 7,
//         subAllocations: {
//             "US Stocks": {
//                 strategic: 30,
//                 tactical: 0,
//                 strategicToleranceLower: 2,
//                 strategicToleranceUpper: 3,
//                 tacticalToleranceLower: 1,
//                 tacticalToleranceUpper: 2,
//                 authorizedAsset: "US Large Cap Equity",
//                 class: "Equity",
//                 subClass: "Large Cap",
//                 strategy: "Passive",
//                 allocationType: "Fixed Weight",
//                 totalToleranceLower: 5,
//                 totalToleranceUpper: 7,
//             },
//             "International Stocks": {
//                 strategic: 20,
//                 tactical: 0,
//                 strategicToleranceLower: 2,
//                 strategicToleranceUpper: 3,
//                 tacticalToleranceLower: 1,
//                 tacticalToleranceUpper: 2,
//                 authorizedAsset: "International Developed Equity",
//                 class: "Equity",
//                 subClass: "International Developed",
//                 strategy: "Active",
//                 allocationType: "Fixed Weight",
//                 totalToleranceLower: 5,
//                 totalToleranceUpper: 7,
//             },
//         },
//     },
//     "Bonds": {
//         strategic: 30,
//         tactical: 0,
//         strategicToleranceLower: 3,
//         strategicToleranceUpper: 5,
//         tacticalToleranceLower: 1,
//         tacticalToleranceUpper: 2,
//         authorizedAsset: "N/A",
//         class: "Fixed Income",
//         subClass: "Government",
//         strategy: "Passive",
//         allocationType: "Fixed Weight",
//         totalToleranceLower: 5,
//         totalToleranceUpper: 7,
//         subAllocations: {
//             "US Bonds": {
//                 strategic: 20,
//                 tactical: 0,
//                 strategicToleranceLower: 2,
//                 strategicToleranceUpper: 3,
//                 tacticalToleranceLower: 1,
//                 tacticalToleranceUpper: 2,
//                 authorizedAsset: "US Government Bonds",
//                 class: "Fixed Income",
//                 subClass: "Government",
//                 strategy: "Passive",
//                 allocationType: "Fixed Weight",
//                 totalToleranceLower: 5,
//                 totalToleranceUpper: 7,
//             },
//             "International Bonds": {
//                 strategic: 10,
//                 tactical: 0,
//                 strategicToleranceLower: 2,
//                 strategicToleranceUpper: 3,
//                 tacticalToleranceLower: 1,
//                 tacticalToleranceUpper: 2,
//                 authorizedAsset: "International Bonds",
//                 class: "Fixed Income",
//                 subClass: "International",
//                 strategy: "Active",
//                 allocationType: "Fixed Weight",
//                 totalToleranceLower: 5,
//                 totalToleranceUpper: 7,
//             },
//         },
//     },
//     "Alternative Investments": {
//         strategic: 20,
//         tactical: 0,
//         strategicToleranceLower: 3,
//         strategicToleranceUpper: 5,
//         tacticalToleranceLower: 1,
//         tacticalToleranceUpper: 2,
//         authorizedAsset: "N/A",
//         class: "Real Estate",
//         subClass: "REITs",
//         strategy: "Active",
//         allocationType: "Fixed Weight",
//         totalToleranceLower: 5,
//         totalToleranceUpper: 7,
//         subAllocations: {
//             "Real Estate": {
//                 strategic: 10,
//                 tactical: 0,
//                 strategicToleranceLower: 1,
//                 strategicToleranceUpper: 2,
//                 tacticalToleranceLower: 1,
//                 tacticalToleranceUpper: 1,
//                 authorizedAsset: "Real Estate Investment Trusts",
//                 class: "Real Estate",
//                 subClass: "REITs",
//                 strategy: "Active",
//                 allocationType: "Fixed Weight",
//                 totalToleranceLower: 5,
//                 totalToleranceUpper: 7,
//             },
//             "Commodities": {
//                 strategic: 5,
//                 tactical: 0,
//                 strategicToleranceLower: 1,
//                 strategicToleranceUpper: 2,
//                 tacticalToleranceLower: 1,
//                 tacticalToleranceUpper: 1,
//                 authorizedAsset: "Commodities",
//                 class: "Commodities",
//                 subClass: "Precious Metals",
//                 strategy: "Passive",
//                 allocationType: "Fixed Weight",
//                 totalToleranceLower: 5,
//                 totalToleranceUpper: 7,
//             },
//             "Cash": {
//                 strategic: 5,
//                 tactical: 0,
//                 strategicToleranceLower: 1,
//                 strategicToleranceUpper: 2,
//                 tacticalToleranceLower: 1,
//                 tacticalToleranceUpper: 1,
//                 authorizedAsset: "Cash and Cash Equivalents",
//                 class: "Cash and Cash Equivalents",
//                 subClass: "Money Market",
//                 strategy: "Passive",
//                 allocationType: "Fixed Weight",
//                 totalToleranceLower: 5,
//                 totalToleranceUpper: 7,
//             },
//         },
//     },
// }
